import { createApiSlice } from "@common";
import { GET_JOB_TITLE } from "@routes";

const apiConfig = [
  {
    name: "getJobTitle",
    method: "get",
    url: GET_JOB_TITLE,
    stateKey: "data",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "jobTitle",
  apiConfig,
  customReducers);
const jobTitleSlice = slice;

export default jobTitleSlice.reducer;

export const {
  getJobTitle,
} = thunks;

export const { rowSelect } = actions;
